import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page-hero mb-4 mb-md-5 text-center"
};
const _hoisted_2 = {
  class: "page-subtitle"
};
const _hoisted_3 = {
  key: 0,
  class: "about-card"
};
const _hoisted_4 = {
  key: 0,
  class: "about-media"
};
const _hoisted_5 = ["alt", "src"];
const _hoisted_6 = {
  class: "about-content-wrap"
};
const _hoisted_7 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_container = _resolveComponent("b-container");
  return $data.networkInfo ? (_openBlock(), _createBlock(_component_b_container, {
    key: 0,
    class: "about-page py-4 py-md-5",
    role: "region",
    "aria-label": "about us"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_row, {
      class: "justify-content-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "12",
        xl: "10"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("h1", {
          id: "main-title",
          class: "page-title"
        }, "About Us", -1)), _createElementVNode("p", _hoisted_2, " Learn more about " + _toDisplayString($data.networkInfo.name || 'this network') + ", its mission, and the content shared with subscribers. ", 1)]), $data.content ? (_openBlock(), _createElementBlock("div", _hoisted_3, [$data.image ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
          class: "about-image",
          alt: $data.networkInfo.name,
          src: $data.image
        }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          class: "about-content",
          innerHTML: $data.content
        }, null, 8, _hoisted_7)])])) : _createCommentVNode("", true)], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true);
}